import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { AnnotationConstraints, DiagramComponent, ImageModel, NodeConstraints, NodeModel, PaletteModel, SelectorConstraints, SelectorModel, SnapConstraints, SnapSettingsModel, ZoomOptions } from '@syncfusion/ej2-angular-diagrams';
import { forkJoin, Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { RentalService } from 'src/app/services/Rental.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-live-market-map',
  templateUrl: './live-market-map.component.html',
  styleUrls: ['./live-market-map.component.scss']
})
export class LiveMarketMapComponent implements OnInit {
  public loaderIcon: Promise<boolean>;
  marketMap: FormGroup;
  @ViewChild('diagram', { static: false })
  public diagram: DiagramComponent;
  private subscriptions: Subscription[] = [];
  selectedDays: Set<number> = new Set();
  public snapSettings: SnapSettingsModel = {
    constraints: SnapConstraints.None,
  };
  parts = [];
  dailyMarketDays = [];
  selectedItems: SelectorModel;
  defaultPart;
  selectedMarketDays = [];
  boothShapes;
  fontName;
  defaultZoomFactor = 0.2;
  fontStyle = [];
  layoutImages = [];
  images = [];
  public palettes?: PaletteModel[];
  marketId;
  marketName = "";
  SwapORamaCustomChanges: boolean=true;
  constructor(
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    private marketInfoService: MarketInfoService,
    private operationRentalService: RentalService,
    public router: Router) {
    this.marketMap = this.formbuilder.group({
      marketParts: [''],
      marketDay :['']
    })
    this.selectedItems = {
      constraints: SelectorConstraints.All &
        ~(SelectorConstraints.ResizeAll | SelectorConstraints.Rotate)
    };
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      this.marketId = params['marketId'];
    });
     this.getParts();
    this.getMarketDetails();
    this.getListOfValuesData();
    this.getImages();
    this.getCustomSettings();
  }

  getCustomSettings() {
    this.operationRentalService.getCustomSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.SwapORamaCustomChanges = res.SwapORamaCustomChanges??false;
      }
    });
  }

  getMarketDetails() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.marketInfoService.getMarketDetails(this.marketId).subscribe((res: any) => {
      if (res) {
        this.marketName = res.MarketName;
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getDailyMarkets() {
    this.subscriptions.push(this.marketInfoService.getDailyMarketDays(this.marketId).subscribe((response) => {
      if (response) {
        this.dailyMarketDays = response;
        if(this.dailyMarketDays.length > 0){
          this.marketMap.get('marketDay').setValue(this.dailyMarketDays[0].MarketDays);
          this.viewLayout();
        }
      }
    }, (err) => {
    }));
  }

  changeMarketMap() {
    this.diagram.clear();
    this.viewLayout();
  }

  getMonthIndex(monthString: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = months.findIndex(month => month.toLowerCase() === monthString.toLowerCase());
    return monthIndex !== -1 ? monthIndex : 0;
  }

  viewLayout() {
    this.diagram.clear();
    this.selectedMarketDays = [];
    if (!this.marketMap.value['marketDay']) {
      Swal.fire({
        // title: $localize`Warning`,
        text: `Please select a Market Day`,
        icon: "warning",
        confirmButtonText: `Ok`,
      });
    }
    else {
      var marketDays =[];
       const d = new Date(this.marketMap.value['marketDay'] + " 00:00:00");
      const timezoneOffset = d.getTimezoneOffset();
      const adjustedDate = new Date(d.getTime() - (timezoneOffset * 60000));
      marketDays.push(adjustedDate);
      this.loaderIcon = Promise.resolve(true);
      this.subscriptions.push(this.marketInfoService.getAllBoothsForDailyRentalTypeLayout(this.marketId, this.marketMap.value['marketParts'], marketDays).subscribe((res: any) => {
        if (res) {
          const data = res;
          this.bindBoothsToLayout(data);
          this.getBuildingForLayout();
          this.getImagesForLayout();
          this.loaderIcon = Promise.resolve(false);
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
      }));
    }
  }

  getParts() {
    this.subscriptions.push(this.marketInfoService.getParts(this.marketId).subscribe((res: any) => {
      if (res) {
        this.parts = res;
        this.getWebRentalSetting();
      }
    }, err => {
    }));
  }

  getWebRentalSetting() {
    this.subscriptions.push(this.marketInfoService.getWebRentalSetting(this.marketId).subscribe((res: any) => {
      if (res) {
        this.defaultPart = res.DefaultLayoutPart;
        if (this.parts.filter(e => e.PartId == this.defaultPart).length == 0) {
          this.defaultPart = this.parts[0].PartId
        }
        this.marketMap.get('marketParts').setValue(this.defaultPart);
        this.getDailyMarkets();
      }
    }, err => {
    }));
  }

  getListOfValuesData() {
    forkJoin({
      res: this.marketInfoService.getListOfValuesData(),
      layoutFonts: this.marketInfoService.getLayoutFonts(this.marketId)
    }).subscribe(({ res, layoutFonts }) => {
      if (res) {
        this.boothShapes = res.BoothShapes;
        this.fontName = res.FontName;
        this.fontStyle = res.FontStyle;
      }
      if (layoutFonts) {
        this.defaultZoomFactor = layoutFonts.DefaultZoomFactor ?? 0;
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  bindBoothsToLayout(data) {
    if (data.length > 0) {
      this.loaderIcon = Promise.resolve(true);
      data.map((item) => {
        const status = (item.Status || '')
          .toString()
          .trim()
          .toLowerCase();

        var fontColor =  status == "r" ? "#fff" : "#000";
        var backColor = "#fff"
        var boothStatus = "Booked";
        switch (status.toLowerCase()) {
          case "r": boothStatus = "Reserved"
            backColor = '#0032CC';
            break;
          case "ro": boothStatus = "Reserved Only"
            backColor = '#483D8B';
            break;
          case "a": boothStatus = "Available"
            backColor = '#fff';
            break;
          case "ab": boothStatus = "Absentee Booking"
            backColor = '#228b22';
            break;
          default: boothStatus = "Booked"
            backColor = '#228b22';
            break;
        }

        if (item.ExcludeForWeb) {
          backColor = '#ff007f';
        }

        const nodeId = 'node_' + item.BoothNumber;
        const diagramNode: NodeModel = {
          id: nodeId,
          shape: {
            type: 'Basic',
            shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0].Name
          },
          style: {
            fill: backColor,
            strokeColor: this.convertColor(item.BorderColor),
            color: fontColor,
            strokeWidth: 1,
            fontSize: item.FontSize,
            textWrapping: 'Wrap',
            fontFamily: this.fontName.filter(e => e.Id == item.FontName)[0].Name
          },
          annotations:
            [{
              content: item.BoothNumber,
              style: {
                fontSize: item.FontSize,
                color: fontColor,
                fontFamily: this.fontName.filter(e => e.Id == item.FontName)[0].Name,
                textWrapping: 'Wrap',
                bold: this.fontStyle.filter(e => e.Id == item.FontStyle)[0].Name.toLowerCase().includes('bold'),
                italic: this.fontStyle.filter(e => e.Id == item.FontStyle)[0].Name.toLowerCase().includes('italic')
              },
              constraints: AnnotationConstraints.ReadOnly
            }],
          width: item.Width * 3,
          height: item.Length * 3,
          addInfo: {
            allowDrag: true,
            name: 'booth',
            status: item.Status
          },
          constraints: NodeConstraints.Default & ~(NodeConstraints.Drag) | NodeConstraints.Tooltip,
          offsetX: item.LeftCoordinate,
          offsetY: item.TopCoordinate,
          rotateAngle: item.RotateAngle
        };
        this.diagram.add(diagramNode);
      });
      this.loaderIcon = Promise.resolve(false);
      this.diagram.fitToPage();
      if (this.defaultZoomFactor) {
        let zoomOptions: ZoomOptions = {
          type: 'ZoomIn',
          zoomFactor: this.defaultZoomFactor
        };
        this.diagram.zoomTo(zoomOptions);
      }
    }
  }

  layoutZoomInClick(event) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomIn",
      zoomFactor: 0.2
    }
    this.diagram.zoomTo(zoomOptions);
  }

  layoutZoomOutClick(flag = false) {
    let zoomOptions: ZoomOptions = {
      type: "ZoomOut",
      zoomFactor: 0.2
    }
    this.diagram.zoomTo(zoomOptions);
  }

  getVerticalText(text: string): string {
    return text.split('').join('\n');
  }

  getBuildingForLayout() {
    const sub = this.marketInfoService.getBuildingAreasInLayOut(this.marketMap.value['marketParts'], this.marketId).subscribe((res: any) => {
      let data = res;
      if (data.length > 0) {
        data.map((item) => {
          const nodeId = 'node_building' + item.BuildingId;
          const diagramNode: NodeModel = {
            id: nodeId,
            shape: {
              type: 'Basic',
              shape: this.boothShapes.filter(e => e.Id == item.ShapeId)[0].Name
            },
            style: {
              fill: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBackColor) : "#000",
              strokeColor: item.BuildingBackColor != 0 ? this.convertColor(item.BuildingBorderColor) : "#000",
              strokeWidth: 1,
              fontSize: item.BuildingFontSize,
              textWrapping: 'Wrap',
              fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0].Name
            },
            annotations:
              [{
                content: item.BuildingVerticalDisplay ? this.getVerticalText(item.Caption) : item.Caption,
                style: {
                  fontSize: item.BuildingFontSize,
                  fontFamily: this.fontName.filter(e => e.Id == item.BuildingFontNameId)[0].Name,
                  textWrapping: 'Wrap',
                  bold: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0].Name.toLowerCase().includes('bold'),
                  italic: this.fontStyle.filter(e => e.Id == item.BuildingFontStyleId)[0].Name.toLowerCase().includes('italic')
                },
                constraints: AnnotationConstraints.ReadOnly
              }],
            width: item.BuildingWidth * 3,
            height: item.BuildingLength * 3,
            addInfo: {
              allowDrag: false, // Enable drag-and-drop for this shape
              id: item.BuildingId,
              name: 'building'
            },
            constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
            offsetX: item.LeftCoordinate,
            offsetY: item.TopCoordinate,
            rotateAngle: item.RotateAngle
          };
          this.diagram.add(diagramNode);
        });
        this.diagram.fitToPage();
        if (this.defaultZoomFactor) {
          let zoomOptions: ZoomOptions = {
            type: 'ZoomIn',
            zoomFactor: this.defaultZoomFactor
          };
          this.diagram.zoomTo(zoomOptions);
        }
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  getImagesForLayout() {
    this.marketInfoService.getLayoutImages(this.marketMap.value['marketParts'], this.marketId).subscribe((response: any) => {
      if (response) {
        let data = response;
        if (data.length > 0) {

          for (let i = 0; i < data.length; i++) {
            let node = {
              id: 'node_images' + data[i].ImagesForLayoutId,
              addInfo: {
                status: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0].ImagePath,
                id: data[i].ImagesForLayoutId,
                name: "image",
                ImageId: data[i].LayoutImagesId,
              },
              style: {
                strokeWidth: 0
              },
              annotations: [
                {
                  //    content: this.layoutImages.filter(e => e.ImageId == data[i].LayoutImagesId)[0].ImageName,
                  constraints: AnnotationConstraints.ReadOnly,
                  offset: { x: 0.05, y: -0.07 }
                }
              ],
              constraints: NodeConstraints.Default & ~(NodeConstraints.Drag),
              shape: { type: 'Image', shape: 'Image' } as ImageModel, // Type assertion to ImageModel
              width: data[i].ImageWidth * 3,
              height: data[i].ImageLength * 3,
              offsetX: data[i].ImageLeftCoordinate,
              offsetY: data[i].ImageTopCoordinate,
              rotateAngle: data[i].RotateAngle
            };

            if ((node.shape as { type: string }).type === 'Image') {
              (node.shape as ImageModel).source = node.addInfo.status;
            }

            this.diagram.add(node);
          }
          this.diagram.fitToPage();
          if (this.defaultZoomFactor) {
            let zoomOptions: ZoomOptions = {
              type: 'ZoomIn',
              zoomFactor: this.defaultZoomFactor
            };
            this.diagram.zoomTo(zoomOptions);
          }
        }
      }
    });
  }

  getImages() {
    const sub = this.marketInfoService.getImages().subscribe((res: any) => {
      if (res) {
        this.layoutImages = res;
        let data = this.layoutImages;
        if (this.layoutImages.length > 0) {
          for (let i = 0; i < this.layoutImages.length; i++) {
            const nodeId = 'node_' + data[i].ImageId;
            let node = {
              id: nodeId, addInfo: {
                status: data[i].ImagePath, id: 'z' + data[i].ImageId, name: "image", ImageId: data[i].ImageId,
              },
              annotations: [{ content: data[i].ImageName, constraints: AnnotationConstraints.ReadOnly, offset: { x: 0.5, y: -0.07 } }],
              shape: { type: 'Image', shape: 'Image' },
              width: 50, height: 50, offsetX: 50, offsetY: 50,
            };
            if (node.shape.type === 'Image') {
              (node.shape as ImageModel).source = node.addInfo.status;
            }
            this.images.push(node);
          }

          this.palettes = [
            {
              id: 'Images',
              expanded: true,
              symbols: this.images,
              title: 'Images'
            },
          ]
        }
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  convertColor(colorValue: number): string {
    if (colorValue == 255 || colorValue == 65280 || colorValue == 0)
      return '#' + colorValue.toString(16).padStart(6, '0');
    else
      return '#' + colorValue.toString(16);
  }

  public created(args: Object): void {
    //fit the diagram to the page with respect to mode and region
    this.diagram.fitToPage({
      mode: 'Page',
      region: 'Content',
      //  margin: {
      //      bottom: 50
      //  },
      canZoomIn: true,
    });
    this.diagram.scrollSettings.horizontalOffset = 0;
    this.diagram.scrollSettings.verticalOffset = 0;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
